import Button from './Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

const Heading = () => {
  return (
    <section className="hero-compact">
      {/* <Image
        src="./assets/homepage.jpeg"
        className="hero-bg-image"
        fluid
        alt="Electroplating facility"
      /> */}
      <div className="hero-gradient"></div>

      <div className="hero-inner">
        <div className="hero-badge">
          <span className="badge-dot"></span>
          Trusted Since 1998
        </div>

        <h1 className="hero-heading">
          Premium <span className="text-highlight">Electroplating</span> & Metal Finishing
        </h1>

        <p className="hero-desc">
          Expert metal coating solutions for automotive, jewelry, furniture, and industrial applications.
        </p>

        <div className="hero-actions">
          <Button to="/contact" variant="primary" size="md">
            Get Free Quote <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
          </Button>
          <Button to="/services" variant="outline" size="md" className="hero-btn-secondary">
            View Services
          </Button>
        </div>

        <div className="hero-stats">
          <div className="hero-stat">
            <span className="stat-num">25+</span>
            <span className="stat-text">Years</span>
          </div>
          <div className="hero-stat-divider"></div>
          <div className="hero-stat">
            <span className="stat-num">500+</span>
            <span className="stat-text">Clients</span>
          </div>
          <div className="hero-stat-divider"></div>
          <div className="hero-stat">
            <span className="stat-num">6</span>
            <span className="stat-text">Industries</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Heading;
